var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoiGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "166px",
    viewBox: "0 0 166 166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.64739045%",
    y1: "50%",
    x2: "100%",
    y2: "44.9945881%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8B00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06400",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    fill: "url(#linearGradient-1)",
    stroke: "#FFFFFF",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 77,
    cy: 77,
    r: 77
  })), /*#__PURE__*/React.createElement("g", {
    id: "local_gas_station_black_24dp",
    transform: "translate(43.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 72 0 72 72 0 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.31,21.69 L59.34,21.66 L49.77,12.09 C48.9,11.22 47.46,11.22 46.59,12.09 C45.72,12.96 45.72,14.4 46.59,15.27 L51.33,20.01 C48.18,21.21 46.05,24.42 46.59,28.14 C47.07,31.44 49.89,34.11 53.19,34.47 C54.6,34.62 55.83,34.38 57,33.87 L57,55.5 C57,57.15 55.65,58.5 54,58.5 C52.35,58.5 51,57.15 51,55.5 L51,42 C51,38.7 48.3,36 45,36 L42,36 L42,15 C42,11.7 39.3,9 36,9 L18,9 C14.7,9 12,11.7 12,15 L12,60 C12,61.65 13.35,63 15,63 L39,63 C40.65,63 42,61.65 42,60 L42,40.5 L46.5,40.5 L46.5,55.08 C46.5,59.01 49.32,62.58 53.22,62.97 C57.72,63.42 61.5,59.91 61.5,55.5 L61.5,27 C61.5,24.93 60.66,23.04 59.31,21.69 Z M36,30 L18,30 L18,18 C18,16.35 19.35,15 21,15 L33,15 C34.65,15 36,16.35 36,18 L36,30 Z M54,30 C52.35,30 51,28.65 51,27 C51,25.35 52.35,24 54,24 C55.65,24 57,25.35 57,27 C57,28.65 55.65,30 54,30 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiGas);
export default __webpack_public_path__ + "static/media/poi-gas.6f28cf6976901604af7e9237735b4b6f.svg";
export { ForwardRef as ReactComponent };